import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import { actions } from "assets/properties/properties";
import { riskWeightageList } from "assets/properties/properties";
const RiskWeightageCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [selectedCategories, setSelectedCategories] = useState({}); // Track selected risk categories
  const [disableSelectFields, setDisableSelectFields] = useState({});
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [weightagePercentage, setWeightagePercentage] = useState({});
  const [weightagePercentageState, setWeightagePercentageState] = useState({});
  const [riskCategory, setRiskCategory] = useState("");
  const [riskCategoryState, setRiskCategoryState] = useState("");
  const viewPage = window.location.href.includes("createView");
  const [riskCategoryData, setRiskCategoryData] = useState([]);
  const [disableButton, setDisabledButton] = useState(false);

  useEffect(() => {
    findAllRiskCategoryWeightageData();
  }, []);

  const findAllRiskCategoryWeightageData = async () => {
    const result = await apiHandler({
      url: endpoint.RISK_WEIGHTAGE_SCORE_FIND_ALL,
      authToken: authToken,
    });
    if (result?.data?.length > 0) {
      setRiskCategoryData(result?.data);
      // Pre-fill selectedCategories and weightagePercentage based on the data
      const initialSelectedCategories = {};
      const initialWeightagePercentage = {};
      result?.data.forEach((item) => {
        initialSelectedCategories[item.id] = item.riskType;
        initialWeightagePercentage[item.id] = item.weightage;
      });
      setSelectedCategories(initialSelectedCategories);
      setWeightagePercentage(initialWeightagePercentage);
    }
  };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const handleDiscrepancySubmit = async (event) => {
    toastUpdate("", "", false);
    let status = "";
      status = await editInformation();
    if (status === actions.success) {
      toastUpdate("Success", "Risk Weightage updated successfully!", true);
      setRedirectURL(`/coreservice/riskCategoryTab`);
    }
  };
  const editInformation = async () => {
      setCallInProgress(true);
      const updatedRiskWeightageData = riskCategoryData.map((item) => ({
        riskType: selectedCategories[item.id],
        weightage: weightagePercentage[item.id],
      }));
      const res = await apiHandler({
        url: endpoint.RISK_WEIGHTAGE_SCORE_UPDATED,
        method: "POST",
        authToken: authToken,
        data: updatedRiskWeightageData,
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return actions.error;
      } else {
        return actions.success;
      }
  };
  const handleCancel = () => {
    navigate("/coreservice/riskCategoryTab");
  };

  const title = viewPage ? "View Risk Weightage" : "Edit Risk Weightage";

  const handleWeightagePercentage = (e, id) => {
    const regex = /^\d*\.?\d*$/;
    if (e === "" || regex?.test(e)) {
      setWeightagePercentage((prev) => ({ ...prev, [id]: e }));
    }
  };

  const handleBlur = async (e, id) => {
    const value = Number(e);
    
    if (isNaN(value) || value === "") {
      toastUpdate("Error", "Invalid weightage value", true);
      setDisabledButton(true);
      return;
    }
  
    // Calculate total weightage excluding the current one being edited
    let totalWeightage = riskCategoryData?.reduce((acc, item) => {
      if (item.id !== id && weightagePercentage[item.id]) {
        return acc + Number(weightagePercentage[item.id]);
      }
      return acc;
    }, 0);
  
    // Check if the value exceeds 100 individually
    if (value > 100) {
      toastUpdate("Error", "Value cannot be greater than 100", true);
      setDisabledButton(true);
      return;
    }
  
    // Add current value to total weightage
    totalWeightage += value;
  
    // Check if total weightage exceeds 100
    if (totalWeightage !== 100) {
      toastUpdate("Error", "Total weightage cannot be less/more than 100", true);
      setDisabledButton(true);
      return;
    }
  
    // If total weightage is 100 or less, update state
    setWeightagePercentage((prev) => ({ ...prev, [id]: value }));
    setDisableSelectFields((prev) => ({ ...prev, [id]: true })); // Disable the select field for this category
    setDisabledButton(false);
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={params?.id ? title : "Risk Weightage"}
          button1={!viewPage && "Save"}
          button2=" Cancel"
          button1click={!viewPage && handleDiscrepancySubmit}
          button2click={handleCancel}
          disabled1={disableButton}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          {riskCategoryData &&
            riskCategoryData?.map((item, index) => (
              <>
                 <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
                  <CustomSelectNew
                    label="Risk*"
                    error={riskCategoryState}
                    id={`risk_type-${item.id}`}
                    value={selectedCategories[item.id]?.toUpperCase()}
                    setState={(value) => setSelectedCategories({ ...selectedCategories, [item.id]: value })}
                    data={riskWeightageList}
                    setError={setRiskCategoryState}
                    disabled={true}
                    type="TYPE"
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
                  <CustomeTextField
                    label="Weightage Percentage (Max 100)"
                    required
                    id={`weightagePercentage-${item.id}`}
                    value={weightagePercentage[item.id] || ""}
                    setState={(e) => handleWeightagePercentage(e, item.id)}
                    error={weightagePercentageState[item.id]}
                    setError={(state) => setWeightagePercentageState((prev) => ({ ...prev, [item.id]: state }))}
                    disabled={viewPage}
                    setBlur={(e) => handleBlur(e, item.id)}
                  />
                </Grid>
              </>
            ))}
        </Grid>
      </Grid>
      {toast && <ToastModal toastMessage={toastMessage} toastMessageType={toastMessageType} toastUpdate={toastUpdate} />}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default RiskWeightageCreate;
